module.exports = __webpack_public_path__ + "img/brushes_jp.89af6f7.jpg";